"use client";

import { cn } from "@/lib/utils";
import { ArrowUp } from "lucide-react";
import { AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { MotionDiv } from "./motion-tags";

export function ScrollToTop() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return null;
}

export function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);



    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY === 0) return setIsVisible(false);
            const threshold = 500; // Adjust this value as needed
            const currentScrollPos = window.pageYOffset;

            setIsVisible(currentScrollPos > threshold);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "auto",
        });
    };

    return (
        <>
            <AnimatePresence initial={false}>
                <MotionDiv
                    onClick={scrollToTop}
                    className={cn(`fixed group bottom-28 md:bottom-[7.25rem] cursor-pointer right-8 bg-custom-secondary z-30 rounded-full p-1.5 h-8 w-8 shadow-lg`)}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 50 }}
                    exit={{ opacity: 0, y: 50 }}
                    transition={{ duration: 0.2 }}
                >
                    <ArrowUp className="h-full w-full text-white" />
                    <span className="sr-only">Back to top</span>
                </MotionDiv>
            </AnimatePresence>
        </>
    );
}